if (!customElements.get('fl27-video')) {
  customElements.define('fl27-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.video = this.querySelector('video');
      if (!this.video) return;
      const button = this.querySelector('.fl27-video-toggle');
      this.onPlay = () => {
        this.classList.add('is-playing');
        if (button) {
          button.setAttribute('aria-label', button.dataset.pause);
          button.setAttribute('aria-pressed', 'true');
          button.querySelector('span').textContent = 'Ⅱ';
        }
        if (!this.hasAttribute('data-ambient')) document.querySelectorAll('fl27-video video').forEach(other => { if (other !== this.video && !other.closest('[data-ambient]')) other.pause(); });
      };
      this.onPause = () => {
        if (button) {
          button.setAttribute('aria-label', button.dataset.play);
          button.setAttribute('aria-pressed', 'false');
          button.querySelector('span').textContent = '▶';
        }
      };
      this.video.addEventListener('play', this.onPlay);
      this.video.addEventListener('pause', this.onPause);
      if (this.hasAttribute('data-ambient')) {
        this.video.muted = true;
        if (button) {
          button.hidden = false;
          button.addEventListener('click', () => {
            this.userPaused = !this.video.paused;
            if (this.video.paused) this.video.play().catch(() => {});
            else this.video.pause();
          });
        }
      }
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (!this.visible) this.video.pause();
        else if (this.hasAttribute('data-ambient') && !this.userPaused && !matchMedia('(prefers-reduced-motion: reduce)').matches && !navigator.connection?.saveData && !document.hidden) this.video.play().catch(() => {});
      }, { threshold: .2 });
      this.observer.observe(this);
      this.onVisibility = () => { if (document.hidden) this.video.pause(); };
      document.addEventListener('visibilitychange', this.onVisibility);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.video?.removeEventListener('play', this.onPlay);
      this.video?.removeEventListener('pause', this.onPause);
      this.initialized = false;
    }
  });
}
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-fl27-dialog]');
  if (trigger) {
    const dialog = document.getElementById(trigger.dataset.fl27Dialog);
    if (!dialog) return;
    dialog.showModal();
    dialog.querySelector('video')?.play().catch(() => {});
    if (!dialog.dataset.initialized) {
      dialog.dataset.initialized = 'true';
      dialog.addEventListener('close', () => dialog.querySelectorAll('video').forEach(video => video.pause()));
      dialog.addEventListener('click', click => {
        if (click.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (click.clientX < rect.left || click.clientX > rect.right || click.clientY < rect.top || click.clientY > rect.bottom) dialog.close();
      });
    }
  }
  const close = event.target.closest('[data-fl27-close]');
  if (close) close.closest('dialog')?.close();
});
